import React, { useState } from 'react';
import './Gallery.css';

function Gallery() {
  const [filter, setFilter] = useState('all');

  const galleryItems = [
    {
      id: 1,
      category: 'blasting',
      title: 'Rock Operation Blasting',
      description: 'Controlled blasting operation in progress',
      video: 'Fredson-Rock-Operation-Blasting-Video.mp4'
    },
    {
      id: 2,
      category: 'blasting',
      title: 'Rock Operation Blasting 2',
      description: 'Precision blasting with safety protocols',
      video: 'Fredson-Rock-Operation-Blasting-Video1.mp4'
    },
    {
      id: 3,
      category: 'drilling',
      title: 'Rock Operation Overview 1',
      description: 'Advanced rock operation in progress',
      video: 'Fredson-Rock-Operation-Overview-Video-1.mp4'
    },
    {
      id: 4,
      category: 'drilling',
      title: 'Rock Operation Overview 10',
      description: 'Equipment and personnel coordination',
      video: 'Fredson-Rock-Operation-Overview-Video-10-1.mp4'
    },
    {
      id: 5,
      category: 'drilling',
      title: 'Rock Operation Overview 10',
      description: 'Deep drilling project execution',
      video: 'Fredson-Rock-Operation-Overview-Video-10.mp4'
    },
    {
      id: 6,
      category: 'drilling',
      title: 'Rock Operation Overview 2',
      description: 'Modern drilling operations in action',
      video: 'Fredson-Rock-Operation-Overview-Video-2.mp4'
    },
    {
      id: 7,
      category: 'drilling',
      title: 'Rock Operation Overview 3',
      description: 'Large-scale rock operation project',
      video: 'Fredson-Rock-Operation-Overview-Video-3.mp4'
    },
    {
      id: 8,
      category: 'drilling',
      title: 'Rock Operation Overview 6',
      description: 'Fleet maintenance and logistics',
      video: 'Fredson-Rock-Operation-Overview-Video-6.mp4'
    },
    {
      id: 9,
      category: 'drilling',
      title: 'Rock Operation Overview 7',
      description: 'Professional rock operations on site',
      video: 'Fredson-Rock-Operation-Overview-Video-7.mp4'
    },
    {
      id: 10,
      category: 'drilling',
      title: 'Rock Operation Overview 9',
      description: 'Specialized drilling operations',
      video: 'Fredson-Rock-Operation-Overview-Video-9.mp4'
    },
    {
      id: 11,
      category: 'drilling',
      title: 'Rock Operation Overview New',
      description: 'Rock drilling project execution',
      video: 'Fredson-Rock-Operation-Overview-Video-New.mp4'
    },
    {
      id: 12,
      category: 'drilling',
      title: 'Rock Operation Overview New 2',
      description: 'Specialized drilling operations',
      video: 'Fredson-Rock-Operation-Overview-Video-New2.mp4'
    },
    {
      id: 13,
      category: 'drilling',
      title: 'Rock Operation Overview New 3',
      description: 'Modern drilling technology in use',
      video: 'Fredson-Rock-Operation-Overview-Video-New3-1.mp4'
    },
    {
      id: 14,
      category: 'drilling',
      title: 'Rock Operation Overview New 3',
      description: 'Modern drilling technology in use',
      video: 'Fredson-Rock-Operation-Overview-Video-New3.mp4'
    },
    {
      id: 15,
      category: 'drilling',
      title: 'Rock Operation Overview New 4',
      description: 'Deep drilling project execution',
      video: 'Fredson-Rock-Operation-Overview-Video-New4.mp4'
    },
    {
      id: 16,
      category: 'drilling',
      title: 'Rock Operation Overview New 5',
      description: 'Professional drilling operations',
      video: 'Fredson-Rock-Operation-Overview-Video-New5.mp4'
    },
    {
      id: 17,
      category: 'drilling',
      title: 'Rock Operation Overview 2',
      description: 'Rock operation equipment in action',
      video: 'Fredson-Rock-Operation-Overview-Video2.mp4'
    },
    {
      id: 18,
      category: 'drilling',
      title: 'Rock Operation Overview 3',
      description: 'On-site drilling and operations',
      video: 'Fredson-Rock-Operation-Overview-Video3-1.mp4'
    },
    {
      id: 19,
      category: 'drilling',
      title: 'Rock Operation Overview 3',
      description: 'On-site drilling and operations',
      video: 'Fredson-Rock-Operation-Overview-Video3-2.mp4'
    },
    {
      id: 20,
      category: 'drilling',
      title: 'Rock Operation Overview 3',
      description: 'On-site drilling and operations',
      video: 'Fredson-Rock-Operation-Overview-Video3-3.mp4'
    },
    {
      id: 21,
      category: 'mining',
      title: 'Fredson Rock Operations',
      description: 'Mining support services and coordination',
      video: 'Fredson-Rock-Video (1).mp4'
    },
    {
      id: 22,
      category: 'mining',
      title: 'Fredson Rock Video',
      description: 'Equipment and personnel coordination',
      video: 'Fredson-Rock-Video.mp4'
    },
    {
      id: 23,
      category: 'blasting',
      title: 'Blasting Activities',
      description: 'Controlled blasting with safety protocols',
      video: 'FredsonRock-Blasting-Activities.mp4'
    },
    {
      id: 24,
      category: 'blasting',
      title: 'Blasting Activities 2',
      description: 'Precision blasting operation',
      video: 'FredsonRock-Blasting-Activities2.mp4'
    },
    {
      id: 25,
      category: 'blasting',
      title: 'Blasting Activities 3',
      description: 'Professional blasting activities',
      video: 'FredsonRock-Blasting-Activities3.mp4'
    },
    {
      id: 26,
      category: 'blasting',
      title: 'Blasting Activities 4',
      description: 'Safe and controlled blasting operations',
      video: 'FredsonRock-Blasting-Activities4.mp4'
    },
    {
      id: 27,
      category: 'blasting',
      title: 'Blasting Activities 5',
      description: 'Rock blasting project execution',
      video: 'FredsonRock-Blasting-Activities5.mp4'
    },
    {
      id: 28,
      category: 'blasting',
      title: 'Quarry Blast in Abuja',
      description: 'Quarry blasting operation in Abuja',
      video: 'Quary-Blast-in-Abuja.mp4'
    },
    {
      id: 29,
      category: 'blasting',
      title: 'Rock Blasting in Abuja',
      description: 'Rock blasting at Bala Mohammed Way, Guzape Abuja',
      video: 'Rock-Blasting-at-Bala-Mohammed-Way-Guzape-Abuja.mp4'
    },
    {
      id: 30,
      category: 'mining',
      title: 'Fredson Rock Field Operations',
      description: 'Field operations and project activities',
      video: 'VID-20240816-WA0001.mp4'
    }
  ];

  const filteredItems = filter === 'all' 
    ? galleryItems 
    : galleryItems.filter(item => item.category === filter);

  return (
    <main className="gallery-page">
      <section className="gallery-hero">
        <div className="container">
          <h1>Gallery</h1>
          <p>View our projects and operations in action</p>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="gallery-filters">
            <button 
              className={`filter-btn ${filter === 'all' ? 'active' : ''}`}
              onClick={() => setFilter('all')}
            >
              All Projects
            </button>
            <button 
              className={`filter-btn ${filter === 'drilling' ? 'active' : ''}`}
              onClick={() => setFilter('drilling')}
            >
              Drilling
            </button>
            <button 
              className={`filter-btn ${filter === 'blasting' ? 'active' : ''}`}
              onClick={() => setFilter('blasting')}
            >
              Blasting
            </button>
            <button 
              className={`filter-btn ${filter === 'construction' ? 'active' : ''}`}
              onClick={() => setFilter('construction')}
            >
              Construction
            </button>
            <button 
              className={`filter-btn ${filter === 'mining' ? 'active' : ''}`}
              onClick={() => setFilter('mining')}
            >
              Mining
            </button>
          </div>

          <div className="gallery-grid">
            {filteredItems.map(item => (
              <div key={item.id} className="gallery-item">
                <div className="gallery-image">
                  <video
                    className="gallery-video"
                    controls
                    preload="metadata"
                    playsInline
                    src={`/videos/${encodeURIComponent(item.video)}`}
                    title={item.title}
                  />
                  <div className="gallery-caption">
                    <h3>{item.title}</h3>
                    <p>{item.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="gallery-cta" style={{ backgroundColor: 'var(--light-color)' }}>
        <div className="container">
          <h2>Ready to View More Projects?</h2>
          <p>Browse our video gallery and project showcase at fredsonrock.com/gallery</p>
          <a href="" className="btn btn-primary" target="" rel="noopener noreferrer">
            View Original Gallery
          </a>
        </div>
      </section>
    </main>
  );
}

export default Gallery;
